export interface ExtensionSortByReportParameter {
   value: ExtensionReportSortBy;
}

export enum ExtensionReportSortBy {
   'Name' = 'Name',
   'Number' = 'Number',
}
